<template>
   <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa fa-map-signs" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-btn class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" variant="primary" size="sm" @click="gPathDashboard()">
              Dashboard
            </b-btn>
            <b-btn class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" variant="primary" size="sm" @click="gPathConfigDashboard()">
              Configuration
            </b-btn>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_maxheight" md="12">
            <b-row class="p-2">
              <!-- loop that will generate the cards -->
              <b-col v-for="(assessment) in assessmentObjList" :key="assessment.gpc_id" class="mobileNoPadding col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                <!-- @todo The Below if has to be removed after changes to backend API. Get Role Specific Event -->
                <iq-card class="rounded iq-card-block iq-card-stretch">
                  <div class="event-images">
                    <a @click="goToGPathAssessment(assessment.gpc_pdt_id)" style="cursor: pointer;">
                      <img style="" v-if="assessment && assessment.gpc_image" :src="assessment.gpc_image" class="img-fluid image image_eventpost" alt="">
                      <div v-else class="image" style="display: flex; text-align: center; background-color: #EEEEEE; border-radius: 5px; border-bottom-left-radius: 0; border-bottom-right-radius: 0;">
                        <span style="margin: auto; font-size: 80px;">{{getFirstLetterOfAString(assessment.gpc_name)}}</span>
                      </div>
                    </a>
                  </div>
                  <b-card-body class="iq-card-body rsvpCardBody">
                    <div class="webKitBox">
                      <div class="events-detail ml-3" @click="goToGPathAssessment(assessment.gpc_pdt_id)" style="cursor: pointer;">
                        <h5 class="twoLineOnly pr-3">
                          {{assessment.gpc_name}}
                        </h5>
                        <p class="twoLineOnly pr-3 vhtmlTag vueHtmlParent mt-3 mb-0" v-html="getResizedText(assessment.gpc_desc)" style="height: 90px; overflow: hidden;"></p>
                      </div>
                    </div>
                    <b-btn class="w-100 mr-2 mt-3 iq-bg-dark" size="md" style="border: none; background: green; color: #fff;" @click="goToGPathAssessment(assessment.gpc_pdt_id)">
                      View Assessment
                    </b-btn>
                  </b-card-body>
                </iq-card>
              </b-col><!-- loop that will generate the cards -->
            </b-row>
          </b-col>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { socialvue } from "../../../config/pluginInit"
import { GPathConfig } from "../../../FackApi/api/GpathConfig"
import ApiResponse from "../../../Utils/apiResponse"

export default {
  name: "GPathAssessment",
  data () {
    return {
      cvCardTitle: "GPaths: Career Assessment",
      cvSearchText: "Type to search",
      whereFilter: {
        search_param: ""
      },
      assessmentObjList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    socialvue.index()
    this.assessmentList()
  },
  methods: {
    /**
     * gPathDashboard
     */
    async gPathDashboard () {
      this.$router.push("/gpath_session_list")
    },
    /**
     * gPathDashboard
     */
    async gPathConfigDashboard () {
      this.$router.push(`/gpath_config_list`)
    },
    /**
     * assessmentList
     */
    async assessmentList () {
      try {
        const gpaList = await GPathConfig.gpcList(this, this.whereFilter)
        if (!gpaList.resp_status) {
          ApiResponse.responseMessageDisplay(this, gpaList)
          return
        }
        this.assessmentObjList = gpaList.resp_data.data
      }
      catch (err) {
        console.error("Exception in assessmentList() and err: ", err.message)
      }
    },
    /**
     * goToGPathAssessment
     */
    goToGPathAssessment (gpathPdtId) {
      this.$router.push(`gpaths/${gpathPdtId}`)
    },
    /**
     * getFirstLetterOfAString
     */
    getFirstLetterOfAString (string) {
      if (string) {
        return string.substr(0, 1)
      }
    },
    /**
     * getResizedText
     */
    getResizedText (text) {
      return text ? text.substr(0, 350) + "..." : ""
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
